import api from "../Api.js";

export default () => {
  async function autenticar(cliente, auth) {
    return await api().post(`/config/auth/${cliente}/login`, auth);
  }

  async function refresh() {
    return await api().post("/config/auth/refresh-token");
  }

  async function sair() {
    return await api().post("/config/auth/logout");
  }

  async function verificaUsuarioTokenCorreto(cliente) {
    return await api().get(`/config/auth/verificacao/${cliente}`);
  }

  return {
    verificaUsuarioTokenCorreto,
    autenticar,
    refresh,
    sair
  };
};
